import {
  ProgressReport,
  SEPOLIA_PUBLIC_COLLECTION,
  Step,
} from "../client/Client";

// This can probably be done with an object (array is problematic due to the gap
// between Done and errors), but I don't know how, especially not in a way where
// missing entries can be detected when compiling.
function step_constants(step: Step): any {
  switch (step) {
    case Step.KeyReservation:
      return {
        text: "Key Reservation",
        tooltip: "Reserving ID on the Keyserver",
        class: "minting",
      };
    case Step.Uploading:
      return {
        text: "Uploading",
        tooltip: "Uploading files and metadata.json to selected storage",
        class: "minting",
      };
    case Step.Minting:
      return {
        text: "Minting",
        tooltip: "Sending on-chain transaction and waiting until inclusion",
        class: "minting",
      };
    case Step.SettingPermissions:
      return {
        text: "Set Permissions",
        tooltip: "Finishing the cNFT by setting the permissions",
        class: "minting",
      };
    case Step.AwaitingFinality:
      return {
        text: "Awaiting Finality",
        tooltip:
          "The NFT is already usable but the owner cannot request the key, yet until the mint transaction is finalized.",
        class: "awaiting-finality",
      };
    case Step.Done:
      return {
        text: "Completed",
        tooltip: "Your cNFT was minted",
        class: "finished",
      };
    case Step.MetaMaskRejected:
      return {
        text: "Failed",
        tooltip: "Transaction failed or signature was rejected",
        class: "failed",
      };
  }
}

interface Props {
  report: ProgressReport;
  name: string;
}

// TODO: Re-render this component to show estimate as a duration? The logic to
// render an (updating) duration should probably be in a separate component.
export function MintProgress({ report, name }: Props) {
  const step = step_constants(report.step);

  // TODO: Make these chain aware
  const view = `sepolia/${SEPOLIA_PUBLIC_COLLECTION}/${report.tokenId?.toString()}`;
  const opensea = `https://testnets.opensea.io/assets/sepolia/${SEPOLIA_PUBLIC_COLLECTION}/${report.tokenId?.toString()}`;

  const isError = report.step > Step.Done;
  const isMinted = !isError && report.tokenId;
  const isSharable = !isError && report.step >= Step.AwaitingFinality;

  return (
    <div className={"mint-progress " + step.class}>
      <div className="row1">
        <b>{name}</b>
        <span title={step.tooltip}>{step.text}</span>
      </div>
      {report.estimate && (
        <span className="estimate">Est. {report.estimate.toString()}</span>
      )}
      <div className="row2">
        {isMinted && (
          <a href={view} target="_blank">
            View
          </a>
        )}
        {isMinted && (
          <a href={opensea} target="_blank">
            OpenSea
          </a>
        )}
        {/* TODO: Implement sharing modal or show buttons directly */}
        {isSharable && <a href="#">Share</a>}
      </div>
    </div>
  );
}
